import { Card, CardHeader, CardTitle } from "reactstrap";
import styled from "styled-components"


export const StyledCardHeader = styled(CardHeader).attrs(() => ({
    className: "text-white bg-header",
}))`
font-family: "baloo";
font-size: 1.3em;`;


export const StyledDiv = styled.div`
margin-top: 15px;
background-color: #d9edf7;
`
export const StyledPara = styled(CardHeader)`
color: #596685;
background-color:#d9edf7;
font-size: 15px;
padding: 10px;
margin-bottom:20px;
`
export const StyledCard = styled(Card).attrs(() => ({
    className: "shadow border-0 text-center bg-gradient-to-r from-cyan-100 to-sky-400  text-dark", body: true
}))`margin-top: 5px;
background-color: ${({ transport = '' }) => {

        if (transport.includes('Stop')) return '#68cf8b';
        if (transport.includes('Start')) return '#8965e0';
        return 'initial';
    }};

`;


export const StyledCardTitle = styled(CardTitle).attrs(() => ({

}))`font-family: "Baloo";
font-size: 25px;`;